import React, { useContext} from "react";

import { useTranslation } from "react-i18next";

import { DepositContext } from "@state/context/payment/DepositContext";
import { observer } from "mobx-react-lite";

export default observer(function SelectedDepositAmount() {
	const depositStore = useContext(DepositContext);

	const currentAmount =
		depositStore.partialDepositAmount ??
		depositStore.currentFormData?.amount ??
		"";

	const { t } = useTranslation("payment");

	return (
		<>
			<label htmlFor="currentAmount" className="label">
				{t<string>("DEPOSIT.DEPOSIT_MONEY")}
			</label>
			<div className="form__field--icon">
				<input
					type="number"
					id="currentAmount"
					className="form__field--icon__input input input--med"
					value={currentAmount}
					disabled
				/>
				<div className="form__field--icon__symbol">
					{depositStore.selectedPaymentMethod?.currencyDisplayCode}
				</div>
			</div>
		</>
	);
});
